import { getIOSVersion, getIOSBrowser } from './iosDetections';
import { getAndroidVersion } from './androidDetections';
import { Browser, DeviceInfo, MobileOS } from './types';

function detectPwaMode() {
  return Boolean(window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone);
}

const detectBrowser = (ua: string): Browser => {
  const browser = getIOSBrowser(ua) || { name: 'other', version: '0.0' };

  return { ...browser, isPwaMode: detectPwaMode() };
};

function detectMobileOS(ua: string): MobileOS | null {
  const androidVersion = ua && getAndroidVersion(ua);

  if (androidVersion) {
    return { name: 'android', version: androidVersion };
  }

  const iosVersion = getIOSVersion(ua);

  if (iosVersion) {
    return { name: 'ios', version: iosVersion };
  }

  return null;
}

export function detectDeviceInfo(ua: string): DeviceInfo {
  return {
    mobileOS: detectMobileOS(ua),
    browser: detectBrowser(ua),
    ua,
  };
}
